import { CircularProgress, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import productBaseService from "services/productBaseService";

import { usePopup } from "../../hooks/usePopup";
import { useDebaunce } from "../../utils/debaunce";
import { searchWithoutAccent } from "../../utils/searchWithoutAccent";

const AutoCompleteProductBase = props => {
  const {
    errors,
    name,
    control,
    defaultValue,
    className,
    onChange,
    disabled,
    onlyPNC
  } = props;
  const { addPopup } = usePopup();
  const [loadingSearchBaseProducts, setLoadingSearchBaseProducts] =
    useState(false);
  const [options, setOptions] = useState([]);

  const handleProductBaseData = async (search = undefined) => {
    try {
      setLoadingSearchBaseProducts(true);
      const response = await productBaseService.list({
        page: 1,
        pageSize: 15,
        search,
        status: "active"
      });

      onlyPNC?.state
        ? setOptions(
            // REVER DEPOIS: LÓGICA DEVERIA ESTAR NO BACK
            response.data.results.filter(product => {
              // Filtra apenas produtos PNC
              if (!product.name.toLowerCase().includes("pnc")) return false;

              const productName = searchWithoutAccent(product.name);
              const originalName = searchWithoutAccent(onlyPNC.productName);
              const searchTerm = search ? searchWithoutAccent(search) : "";

              // Se há busca, produto deve conter o termo
              if (searchTerm && !productName.includes(searchTerm)) return false;

              // Filtra palavras do produto original (primeira palavra é a mais importante)
              const originalWords = originalName
                .split(" ")
                .filter(word => word.length > 2);

              if (originalWords.length === 0) return false;

              // Remove "pnc" e limpa o nome do produto
              const cleanProductName = productName.replace(/pnc/g, "").trim();

              // Verifica se o produto PNC começa com a primeira palavra do produto original
              const firstOriginalWord = originalWords[0];
              return cleanProductName.startsWith(firstOriginalWord);
            })
          )
        : setOptions(response.data.results);
    } catch (err) {
      if (err?.response?.status) {
        addPopup({
          type: "error",
          title: "Desculpe, ocorreu um erro",
          description: "Erro ao pesquisar produto base."
        });
      }
    } finally {
      setLoadingSearchBaseProducts(false);
    }
  };

  const debaunce = useDebaunce({ fn: handleProductBaseData, delay: 500 });

  const handleProductBase = e => {
    debaunce(e.target.value);
  };

  useEffect(() => {
    if (disabled) return;

    handleProductBaseData();
  }, []);

  if (control) {
    return (
      <Controller
        defaultValue={defaultValue || null}
        disabled={disabled}
        render={({ field }) => (
          <Autocomplete
            loading={loadingSearchBaseProducts}
            options={options}
            getOptionLabel={option => option.name}
            onChange={(_, data) => {
              field.onChange(data);
              onChange && onChange(data);
            }}
            value={field.value}
            className={className}
            noOptionsText="Produto não encontrado"
            loadingText="Procurando produto..."
            disabled={disabled}
            renderInput={params => (
              <TextField
                {...params}
                variant="outlined"
                label="Produto Base"
                error={!!errors?.[name]}
                helperText={errors?.[name]?.message}
                disabled={disabled}
                onChange={handleProductBase}
                InputProps={{
                  ...params.InputProps,
                  className: className,
                  clearButton: false,
                  endAdornment: (
                    <>
                      {loadingSearchBaseProducts && (
                        <CircularProgress color="inherit" size={20} />
                      )}
                      {params.InputProps.endAdornment}
                    </>
                  )
                }}
              />
            )}
          />
        )}
        name={name}
        control={control}
      />
    );
  }

  return (
    <Autocomplete
      loading={loadingSearchBaseProducts}
      options={options}
      getOptionLabel={option => option.name}
      onChange={onChange}
      className={className}
      noOptionsText="Produto não encontrado"
      loadingText="Procurando produto..."
      defaultValue={defaultValue || null}
      disabled={disabled}
      renderInput={params => (
        <TextField
          {...params}
          variant="outlined"
          label="Produto Base"
          onChange={handleProductBase}
          disabled={disabled}
          InputProps={{
            ...params.InputProps,
            className: className,
            clearButton: false,
            endAdornment: (
              <>
                {loadingSearchBaseProducts && (
                  <CircularProgress color="inherit" size={20} />
                )}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
    />
  );
};

export default AutoCompleteProductBase;
